module.exports = __webpack_public_path__ + "img/logo_indogold1.ae16da2c.png";